import Helpers from '@Apis/helpers';
import Constants from '@Apis/constants';

class AnalyticsServices {
  // purchase
    /**
     *
     * @param startDate
     * @param endDate
     * @param tenantIds
     * @returns {Promise<*>}
     */
    getTotalSpend = async (startDate, endDate, tenantIds) => {
      let url = `${Constants.ANALYTICS}/purchase_bi/total_spend?`;
      if (startDate) url += `from_date=${startDate}&`;
      if (endDate) url += `to_date=${endDate}&`;
      if (tenantIds) url += `tenant_ids=${tenantIds}&`;
      const response = await Helpers.get({ url });
      return response;
    }

    /**
     *
     * @param startDate
     * @param endDate
     * @param tenantIds
     * @param sellerId
     * @returns {Promise<*>}
     */
    getPurchaseByStatus = async (startDate, endDate, tenantIds, sellerId) => {
      let url = `${Constants.ANALYTICS}/purchase_bi/po_rec_status_split?`;
      if (startDate) url += `from_date=${startDate}&`;
      if (endDate) url += `to_date=${endDate}&`;
      if (tenantIds) url += `tenant_ids=${tenantIds}&`;
      if (sellerId) url += `seller_id=${sellerId}&`;
      const response = await Helpers.get({ url });
      return response;
    }

    /**
     *
     * @param startDate
     * @param endDate
     * @param tenantIds
     * @param sellerId
     * @returns {Promise<*>}
     */
    getPurchaseByApprovalStatus = async (startDate, endDate, tenantIds, sellerId) => {
      let url = `${Constants.ANALYTICS}/purchase_bi/po_status_split?`;
      if (startDate) url += `from_date=${startDate}&`;
      if (endDate) url += `to_date=${endDate}&`;
      if (tenantIds) url += `tenant_ids=${tenantIds}&`;
      if (sellerId) url += `seller_id=${sellerId}&`;
      const response = await Helpers.get({ url });
      return response;
    }

    /**
     *
     * @param startDate
     * @param endDate
     * @param tenantIds
     * @param groupType
     * @returns {Promise<*>}
     */
    getPurchaseSchedule = async (startDate, endDate, tenantIds, groupType) => {
      let url = `${Constants.ANALYTICS}/purchase_bi/pending_delivery_pos?`;
      if (startDate) url += `from_date=${startDate}&`;
      if (endDate) url += `to_date=${endDate}&`;
      if (tenantIds) url += `tenant_ids=${tenantIds}&`;
      if (groupType) url += `group_type=${groupType}&`;
      const response = await Helpers.get({ url });
      return response;
    }

    /**
     *
     * @param tenantIds
     * @returns {Promise<*>}
     */
    getOverdueGrn = async (tenantIds) => {
      let url = `${Constants.ANALYTICS}/purchase_bi/overdue_grns?`;
      if (tenantIds) url += `tenant_ids=${tenantIds}&`;
      const response = await Helpers.get({ url });
      return response;
    }

    /**
     *
     * @param startDate
     * @param endDate
     * @param tenantIds
     * @returns {Promise<*>}
     */
    getPrByDepartment = async (startDate, endDate, tenantIds) => {
      let url = `${Constants.ANALYTICS}/purchase_bi/pr_analytics?`;
      if (tenantIds) url += `tenant_ids=${tenantIds}&`;
      if (startDate) url += `from_date=${startDate}&`;
      if (endDate) url += `to_date=${endDate}&`;
      const response = await Helpers.get({ url });
      return response;
    }

    /**
     *
     * @param tenantIds
     * @returns {Promise<*>}
     */
    getInvStockStatusSplit = async (tenantIds) => {
      let url = `${Constants.ANALYTICS}/inventory_bi/product_count_status?`;
      if (tenantIds) url += `tenant_ids=${tenantIds}&`;
      const response = await Helpers.get({ url });
      return response;
    }

    /**
     *
     * @param tenantIds
     * @returns {Promise<*>}
     */
    getInvStockValuation = async (tenantIds) => {
      let url = `${Constants.ANALYTICS}/inventory_bi/stock_value?`;
      if (tenantIds) url += `tenant_ids=${tenantIds}&`;
      const response = await Helpers.get({ url });
      return response;
    }

    /**
     *
     * @param tenantIds
     * @returns {Promise<*>}
     */
    getInvOpenStockTransfers = async (tenantIds) => {
      let url = `${Constants.ANALYTICS}/inventory_bi/incoming_st_count?`;
      if (tenantIds) url += `tenant_ids=${tenantIds}&`;
      const response = await Helpers.get({ url });
      return response;
    }

    /**
     *
     * @param tenantIds
     * @param interval
     * @param steps
     * @returns {Promise<*>}
     */
    getInvAgeingSplit = async (tenantIds, interval, steps) => {
      let url = `${Constants.ANALYTICS}/inventory_bi/stock_value_by_ageing?`;
      if (tenantIds) url += `tenant_ids=${tenantIds}&`;
      if (interval) url += `interval=${interval}&`;
      if (steps) url += `steps=${steps}&`;
      const response = await Helpers.get({ url });
      return response;
    }

    // Production BI
    /**
     *
     * @param startDate
     * @param endDate
     * @param tenantIds
     * @returns {Promise<*>}
     */
     getProductionOutput = async (startDate, endDate, tenantIds) => {
       let url = `${Constants.ANALYTICS}/production_bi/production_output?`;
       if (startDate) url += `from_date=${startDate}&`;
       if (endDate) url += `to_date=${endDate}&`;
       if (tenantIds) url += `tenant_ids=${tenantIds}&`;
       const response = await Helpers.get({ url });
       return response;
     }

     /**
     *
     * @param startDate
     * @param endDate
     * @param tenantIds
     * @returns {Promise<*>}
     */
     getProductionDeliveryTimeliness = async (startDate, endDate, tenantIds) => {
       let url = `${Constants.ANALYTICS}/production_bi/production_delivery_timeliness?`;
       if (startDate) url += `from_date=${startDate}&`;
       if (endDate) url += `to_date=${endDate}&`;
       if (tenantIds) url += `tenant_ids=${tenantIds}&`;
       const response = await Helpers.get({ url });
       return response;
     }

     /**
     *
     * @param startDate
     * @param endDate
     * @param tenantIds
     * @returns {Promise<*>}
     */
     getProductionTrend = async (startDate, endDate, tenantIds) => {
       let url = `${Constants.ANALYTICS}/production_bi/production_trend?`;
       if (startDate) url += `from_date=${startDate}&`;
       if (endDate) url += `to_date=${endDate}&`;
       if (tenantIds) url += `tenant_ids=${tenantIds}&`;
       const response = await Helpers.get({ url });
       return response;
     }

     /**
     *
     * @param startDate
     * @param endDate
     * @param tenantIds
     * @returns {Promise<*>}
     */
     getProductionProductWise = async (startDate, endDate, tenantIds) => {
       let url = `${Constants.ANALYTICS}/production_bi/production_product_wise?`;
       if (startDate) url += `from_date=${startDate}&`;
       if (endDate) url += `to_date=${endDate}&`;
       if (tenantIds) url += `tenant_ids=${tenantIds}&`;
       const response = await Helpers.get({ url });
       return response;
     }

     /**
     *
     * @param startDate
     * @param endDate
     * @param tenantIds
     * @returns {Promise<*>}
     */
     getProductionValue = async (startDate, endDate, tenantIds, method) => {
       let url = `${Constants.ANALYTICS}/production_bi/finished_good_value?`;
       if (startDate) url += `from_date=${startDate}&`;
       if (endDate) url += `to_date=${endDate}&`;
       if (tenantIds) url += `tenant_ids=${tenantIds}&`;
       if (method) url += `method=${method}&`;
       const response = await Helpers.get({ url });
       return response;
     }

     /**
     *
     * @param startDate
     * @param endDate
     * @param tenantIds
     * @returns {Promise<*>}
     */
       getProductionByStatus = async (startDate, endDate, tenantIds) => {
         let url = `${Constants.ANALYTICS}/production_bi/mo_status_split?`;
         if (startDate) url += `from_date=${startDate}&`;
         if (endDate) url += `to_date=${endDate}&`;
         if (tenantIds) url += `tenant_ids=${tenantIds}&`;
         const response = await Helpers.get({ url });
         return response;
       }

       /**
     *
     * @param startDate
     * @param endDate
     * @param tenantIds
     * @returns {Promise<*>}
     */
       getProductionByMachineStatus = async (startDate, endDate, tenantIds) => {
         let url = `${Constants.ANALYTICS}/production_bi/machine_status?`;
         if (startDate) url += `from_date=${startDate}&`;
         if (endDate) url += `to_date=${endDate}&`;
         if (tenantIds) url += `tenant_ids=${tenantIds}&`;
         const response = await Helpers.get({ url });
         return response;
       }

       /**
     *
     * @param tenantIds
     * @returns {Promise<*>}
     */
    getOverdueScheduleMO = async (startDate, endDate, tenantIds) => {
      let url = `${Constants.ANALYTICS}/production_bi/mo_schedule_mo_overdue?`;
      if (startDate) url += `from_date=${startDate}&`;
      if (endDate) url += `to_date=${endDate}&`;
      if (tenantIds) url += `tenant_ids=${tenantIds}&`;
      const response = await Helpers.get({ url });
      return response;
    }

    /**
     *
     * @param tenantIds
     * @returns {Promise<*>}
     */
     getResourceWorkLoadList = async (tenantIds) => {
       let url = `${Constants.ANALYTICS}/production_bi/resource_workload_list?`;
       if (tenantIds) url += `tenant_ids=${tenantIds}&`;
       const response = await Helpers.get({ url });
       return response;
     }

    /**
     *
     * @param tenantIds
     * @returns {Promise<*>}
     */
    getAssignessWorkLoadList = async (tenantIds) => {
      let url = `${Constants.ANALYTICS}/production_bi/assignee_workload_list?`;
      if (tenantIds) url += `tenant_ids=${tenantIds}&`;
      const response = await Helpers.get({ url });
      return response;
    }

    /**
     *
     * @param tenantIds
     * @returns {Promise<*>}
     */
    getAverageOrderValue = async (params) => {
      const {
        startDate, endDate, tenantIds, source, accountManagerIds, customerIds, isInclusiveOfTax,
      } = params;
      let url = `${Constants.ANALYTICS}/sales_bi/average_order_value?`;
      if (startDate) url += `from_date=${startDate}&`;
      if (endDate) url += `to_date=${endDate}&`;
      if (tenantIds) url += `tenant_ids=${tenantIds}&`;
      if (source) url += `source=${source}&`;
      if (accountManagerIds) url += `account_manager_ids=${accountManagerIds}&`;
      if (customerIds) url += `customer_ids=${customerIds}&`;
      if (isInclusiveOfTax) url += `is_inclusive_of_tax=${isInclusiveOfTax}&`;

      const response = await Helpers.get({ url });
      return response;
    }

    /**
     *
     * @param tenantIds
     * @returns {Promise<*>}
     */
    getOrderStatistics = async (params) => {
      const {
        startDate, endDate, tenantIds, source, accountManagerIds, customerIds, isInclusiveOfTax,
      } = params;
      let url = `${Constants.ANALYTICS}/sales_bi/order_statistics?`;
      if (startDate) url += `from_date=${startDate}&`;
      if (endDate) url += `to_date=${endDate}&`;
      if (tenantIds) url += `tenant_ids=${tenantIds}&`;
      if (source) url += `source=${source}&`;
      if (accountManagerIds) url += `account_manager_ids=${accountManagerIds}&`;
      if (customerIds) url += `customer_ids=${customerIds}&`;
      if (isInclusiveOfTax) url += `is_inclusive_of_tax=${isInclusiveOfTax}&`;

      const response = await Helpers.get({ url });
      return response;
    }

    /**
     *
     * @param tenantIds
     * @returns {Promise<*>}
     */
    getOnTimeDelivery = async (params) => {
      const {
        startDate, endDate, tenantIds, source, accountManagerIds, customerIds,
      } = params;
      let url = `${Constants.ANALYTICS}/sales_bi/on_time_delivery?`;
      if (startDate) url += `from_date=${startDate}&`;
      if (endDate) url += `to_date=${endDate}&`;
      if (tenantIds) url += `tenant_ids=${tenantIds}&`;
      if (source) url += `source=${source}&`;
      if (accountManagerIds) url += `account_manager_ids=${accountManagerIds}&`;
      if (customerIds) url += `customer_ids=${customerIds}&`;
      const response = await Helpers.get({ url });
      return response;
    }

    /**
     *
     * @param tenantIds
     * @returns {Promise<*>}
     */
    getOrderCountByStatus = async (params) => {
      const {
        startDate, endDate, tenantIds, source, accountManagerIds, customerIds,
      } = params;
      let url = `${Constants.ANALYTICS}/sales_bi/order_count_by_status?`;
      if (startDate) url += `from_date=${startDate}&`;
      if (endDate) url += `to_date=${endDate}&`;
      if (tenantIds) url += `tenant_ids=${tenantIds}&`;
      if (source) url += `source=${source}&`;
      if (accountManagerIds) url += `account_manager_ids=${accountManagerIds}&`;
      if (customerIds) url += `customer_ids=${customerIds}&`;
      const response = await Helpers.get({ url });
      return response;
    }

    /**
     *
     * @param tenantIds
     * @returns {Promise<*>}
     */
    getOrderTrend = async (params) => {
      const {
        startDate, endDate, tenantIds, source, accountManagerIds, customerIds, isInclusiveOfTax, 
      } = params;
      let url = `${Constants.ANALYTICS}/sales_bi/order_trend?`;
      if (startDate) url += `from_date=${startDate}&`;
      if (endDate) url += `to_date=${endDate}&`;
      if (tenantIds) url += `tenant_ids=${tenantIds}&`;
      if (source) url += `source=${source}&`;
      if (accountManagerIds) url += `account_manager_ids=${accountManagerIds}&`;
      if (customerIds) url += `customer_ids=${customerIds}&`;
      if (isInclusiveOfTax) url += `is_inclusive_of_tax=${isInclusiveOfTax}&`;

      const response = await Helpers.get({ url });
      return response;
    }

    /**
     *
     * @param tenantIds
     * @returns {Promise<*>}
     */
    getOrderValueByType = async (params) => {
      const {
        startDate, endDate, tenantIds, type, source, accountManagerIds, customerIds, isInclusiveOfTax,
      } = params;
      let url = `${Constants.ANALYTICS}/sales_bi/order_value_by_type?`;
      if (startDate) url += `from_date=${startDate}&`;
      if (endDate) url += `to_date=${endDate}&`;
      if (tenantIds) url += `tenant_ids=${tenantIds}&`;
      if (type) url += `type=${type}&`;
      if (source) url += `source=${source}&`;
      if (accountManagerIds) url += `account_manager_ids=${accountManagerIds}&`;
      if (customerIds) url += `customer_ids=${customerIds}&`;
      if (isInclusiveOfTax) url += `is_inclusive_of_tax=${isInclusiveOfTax}&`;

      const response = await Helpers.get({ url });
      return response;
    }

    /**
     *
     * @param tenantIds
     * @returns {Promise<*>}
     */
    getOrderValueByCustomer = async (params) => {
      const {
        startDate, endDate, tenantIds, source, accountManagerIds, customerIds, isInclusiveOfTax,
      } = params;
      let url = `${Constants.ANALYTICS}/sales_bi/order_value_by_customer?`;
      if (startDate) url += `from_date=${startDate}&`;
      if (endDate) url += `to_date=${endDate}&`;
      if (tenantIds) url += `tenant_ids=${tenantIds}&`;
      if (source) url += `source=${source}&`;
      if (accountManagerIds) url += `account_manager_ids=${accountManagerIds}&`;
      if (customerIds) url += `customer_ids=${customerIds}&`;
      if (isInclusiveOfTax) url += `is_inclusive_of_tax=${isInclusiveOfTax}&`;

      const response = await Helpers.get({ url });
      return response;
    }

    /**
     *
     * @param tenantIds
     * @returns {Promise<*>}
     */
    getOrderValueByProduct = async (params) => {
      const {
        startDate, endDate, tenantIds, source, accountManagerIds, customerIds, isInclusiveOfTax,
      } = params;
      let url = `${Constants.ANALYTICS}/sales_bi/order_value_by_product?`;
      if (startDate) url += `from_date=${startDate}&`;
      if (endDate) url += `to_date=${endDate}&`;
      if (tenantIds) url += `tenant_ids=${tenantIds}&`;
      if (source) url += `source=${source}&`;
      if (accountManagerIds) url += `account_manager_ids=${accountManagerIds}&`;
      if (customerIds) url += `customer_ids=${customerIds}&`;
      if (isInclusiveOfTax) url += `is_inclusive_of_tax=${isInclusiveOfTax}&`;

      const response = await Helpers.get({ url });
      return response;
    }

    /**
     *
     * @param tenantIds
     * @returns {Promise<*>}
     */
    getOrderValueBySalesPerson = async (params) => {
      const {
        startDate, endDate, tenantIds, source, accountManagerIds, customerIds, isInclusiveOfTax,
      } = params;
      let url = `${Constants.ANALYTICS}/sales_bi/order_value_by_sales_person?`;
      if (startDate) url += `from_date=${startDate}&`;
      if (endDate) url += `to_date=${endDate}&`;
      if (tenantIds) url += `tenant_ids=${tenantIds}&`;
      if (source) url += `source=${source}&`;
      if (accountManagerIds) url += `account_manager_ids=${accountManagerIds}&`;
      if (customerIds) url += `customer_ids=${customerIds}&`;
      if (isInclusiveOfTax) url += `is_inclusive_of_tax=${isInclusiveOfTax}&`;

      const response = await Helpers.get({ url });
      return response;
    }

    /**
     *
     * @param tenantIds
     * @returns {Promise<*>}
     */
    getOrderValueBySource = async (params) => {
      const {
        startDate, endDate, tenantIds, source, accountManagerIds, customerIds, isInclusiveOfTax,
      } = params;
      let url = `${Constants.ANALYTICS}/sales_bi/order_value_by_source?`;
      if (startDate) url += `from_date=${startDate}&`;
      if (endDate) url += `to_date=${endDate}&`;
      if (tenantIds) url += `tenant_ids=${tenantIds}&`;
      if (source) url += `source=${source}&`;
      if (accountManagerIds) url += `account_manager_ids=${accountManagerIds}&`;
      if (customerIds) url += `customer_ids=${customerIds}&`;
      if (isInclusiveOfTax) url += `is_inclusive_of_tax=${isInclusiveOfTax}&`;

      const response = await Helpers.get({ url });
      return response;
    }

    /**
     *
     * @param tenantIds
     * @returns {Promise<*>}
     */
    getCustomerWiseGrowth = async (params) => {
      const {
        startDate, endDate, tenantIds, source, interval, accountManagerIds, customerIds, isInclusiveOfTax,
      } = params;
      let url = `${Constants.ANALYTICS}/sales_bi/sales_growth_by_customer?`;
      if (startDate) url += `from_date=${startDate}&`;
      if (endDate) url += `to_date=${endDate}&`;
      if (tenantIds) url += `tenant_ids=${tenantIds}&`;
      if (source) url += `source=${source}&`;
      if (interval) url += `interval=${interval}&`;
      if (accountManagerIds) url += `account_manager_ids=${accountManagerIds}&`;
      if (customerIds) url += `customer_ids=${customerIds}&`;
      if (isInclusiveOfTax) url += `is_inclusive_of_tax=${isInclusiveOfTax}&`;

      const response = await Helpers.get({ url });
      return response;
    }

    /**
     *
     * @param tenantIds
     * @returns {Promise<*>}
     */
    getOrderReceivables = async (params) => {
      const {
        startDate, endDate, tenantIds, source, accountManagerIds, customerIds,
      } = params;
      let url = `${Constants.ANALYTICS}/sales_bi/order_receivables?`;
      if (startDate) url += `from_date=${startDate}&`;
      if (endDate) url += `to_date=${endDate}&`;
      if (tenantIds) url += `tenant_ids=${tenantIds}&`;
      if (source) url += `source=${source}&`;
      if (accountManagerIds) url += `account_manager_ids=${accountManagerIds}&`;
      if (customerIds) url += `customer_ids=${customerIds}&`;

      const response = await Helpers.get({ url });
      return response;
    }

    /**
     *
     * @param url
     * @returns {Promise<*>}
     */
    downloadDocument = async (url) => {
      const document = await Helpers.getFile({ url });
      return document;
    }

    printLabels = async (payload) => {
      const {
        documentId,
        entityName,
        labelTemplateId,
        batchCopiesData,
        batchConfig,
      } = payload;

      let url = `${Constants.BASE_URL}/label_templates/download_labels?`;
      if (documentId) url += `document_id=${documentId}&`;
      if (entityName) url += `entity_name=${entityName}&`;
      if (labelTemplateId) url += `label_template_id=${labelTemplateId}&`;
      if (batchCopiesData) url += `batch_copies_data=${JSON.stringify(batchCopiesData)}&`;
      if (batchConfig) url += `batch_config=${JSON.stringify(batchConfig)}&`;

      const document = await Helpers.get({ url });
      return document;
    }

    // commonGetRequest
  commonGetRequests = async (url) => {
    const commonGetRequest = await Helpers.get({ url });
    return commonGetRequest;
  }

    /**
     *
     * @param page
     * @param limit
     * @returns {Promise<*>}
     */
    getBulkUploads = async (page, limit) => {
      let url = `${Constants.BULK_UPLOADS}?`;
      if (page) url += `page=${page}&`;
      if (limit) url += `limit=${limit}&`;
      const bulkUploads = await Helpers.get({ url });
      return bulkUploads;
    }
}
export default new AnalyticsServices();
